import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	BLUE,
	GRAY,
	PRIMARY_COLOR,
	WHITE,
} from '../../../../styles/colors.style'

export const Container = styled.section`
	text-align: center;

	.title {
		font-size: 2.3rem;
		padding: 10px 0 0;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: 3rem;
		}
	}

	.extract-button {
		background: linear-gradient(180deg, ${PRIMARY_COLOR} 0%, #f9bf2b 193.64%);
		border-radius: 5px;
		color: ${WHITE};
		font-size: 1.8rem;
		line-height: 40px;
		text-align: center;
		display: block;
		width: 60%;
		margin: 20px auto;
		height: 40px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 400px;
			height: 64px;
			font-size: 2rem;
			line-height: 64px;
			font-weight: 600;
			margin-bottom: 40px;
		}
	}
`

export const TransactionNumber = styled.p`
	color: ${GRAY};
	margin: 10px 0;
	font-size: 2.5rem;
	line-height: 38px;

	&:first-child {
		margin-top: 10px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		margin: 30px 0;

		&:first-child {
			margin-top: 40px;
		}
	}
`

export const Number = styled.strong`
	color: ${BLUE};
	font-weight: 600;
`

export const ConfirmationMessage = styled(TransactionNumber)`
	color: ${PRIMARY_COLOR};
	line-height: 30px;
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		line-height: 38px;
	}
`

export const Contact = styled.small`
	color: ${GRAY};
	font-size: 1.6rem;
	display: block;
	padding-bottom: 15px;
`
export const Email = styled.a`
	color: ${GRAY};
	text-decoration: underline;
`
